import { render, staticRenderFns } from "./rekomendasi.vue?vue&type=template&id=7d064591"
import script from "./rekomendasi.vue?vue&type=script&lang=js"
export * from "./rekomendasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports